import { useTranslation } from 'react-i18next'
import { EarnAssetsList, EarnMyAsset } from './EarnAssetsList'

export interface EarnNoPortfolioProps {
  assets: EarnMyAsset[]
  showCustomerEarnRate?: boolean
}

export const EarnNoPortfolio = ({ assets, showCustomerEarnRate = true }: EarnNoPortfolioProps) => {
  const { t } = useTranslation()

  return (
    <EarnAssetsList
      assets={assets}
      showCustomerEarnRate={showCustomerEarnRate}
      title={t('earn.noPortfolioState.title')}
      allocatedColumnLabel={t('earn.availableInWalletsColumn')}
      myEarnRateColumnLabel={t('earn.earnRateColumn')}
      depositOnly
    />
  )
}
